import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
// 在应用启动时建立连接
onMounted(async () => {
  try {
    const client = TelegramClient.getInstance();
    await client.connect();
    console.log("WebSocket 连接已建立");
  } catch (error) {
    console.error("WebSocket 连接失败:", error);
  }

  localStorage.setItem("isLoggedIn", "false");
  router.push("/login");
});

// 在应用关闭时断开连接
onUnmounted(() => {
  const client = TelegramClient.getInstance();
  client.disconnect();
});

const clearSession = () => {
  localStorage.removeItem("session");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("username");
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})